import './StreamingIndicator.css';

interface StreamingIndicatorProps {
  isVisible: boolean;
}

export function StreamingIndicator({ isVisible }: StreamingIndicatorProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className="streaming-indicator"
      role="status"
      aria-label="Assistant is typing"
    >
      <span className="streaming-dot" aria-hidden="true" />
      <span className="streaming-dot" aria-hidden="true" />
      <span className="streaming-dot" aria-hidden="true" />
    </div>
  );
}
